<template>
  <div>
    <Pos_add_product_service/>
  </div>
</template>

<script>
import Pos_add_product_service
  from "@/components/adminArin/pos_system/warehouse/manage_product/Pos_add_product_service";
export default {
  name: "PosAddProductService",
  components: {
    Pos_add_product_service
  }
}
</script>

<style scoped>

</style>
